<div>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>{{pack.name[lang]}}</mat-card-title>
    </mat-card-header>
    <img mat-card-image [src]="img" alt={{pack.name[lang]}}>
    <mat-card-content>
      <div *ngFor="let tile of tiles[lang]">
        <ul>
          <li>{{tile.text}}</li>
        </ul>
      </div>
      <p><strong>{{ 'packsTexts.validity' | translate }}:</strong> {{validityText}} </p>
      <p><strong>{{ 'common.price' | translate }}:</strong>
        <ng-container *ngIf="pack?.currencyCode">
          <span [ngClass]="{ 'hide': pack.currencyCode === 'EUR' }" *ngIf="pack.currencyCode === 'BGN'">
            {{ pack.price | localizedCurrency }} / {{ (pack.price / 1.95583) | currency:'EUR':'symbol':'1.2-2':'de-DE' }} 
          </span>
          <span *ngIf="pack.currencyCode === 'EUR'">
            {{ pack.price | currency:'EUR':'symbol':'1.2-2':'de-DE'}} / {{ (pack.price * 1.95583) | currency:'BGN':'symbol':'1.2-2':'bg-BG' }}
          </span>
        </ng-container>
      </p>

    </mat-card-content>
    <button mat-raised-button color="primary" (click)="onOrderClick(pack.id)">
      {{buyPack}}
    </button>
  </mat-card>
</div>